var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"mm",style:({'background-image':("url(" + _vm.img + ")")})}),_c('div',{staticClass:"banner-img"},[_c('img',{attrs:{"src":_vm.img}})]),_c('div',{staticClass:"banner-title"})])}
var staticRenderFns = []

export { render, staticRenderFns }